module.exports = __webpack_public_path__ + "static/media/banner_el_GR.060bb3fc.png";